// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".font-off-white[data-v-b7eb74a2]{color:#c9d6df}", ""]);
// Exports
module.exports = exports;
